/* import __COLOCATED_TEMPLATE__ from './metric-card.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */
import Component from '@glimmer/component';
import type { JobGroupObject } from 'embercom/components/reporting/automation/ai-insights/optimize/jobs';
import type { ReportState } from 'embercom/components/reporting/custom/report/chart-card';
import { staticDataResource } from 'embercom/lib/reporting/static-data-resource';
import { use } from 'ember-resources/util/function-resource';
import type { PercentageMetricValue } from 'embercom/lib/reporting/chart-data-resource';

interface Signature {
  reportState: ReportState;
  jobGroupObject: JobGroupObject;
}

const TICK_WIDTH = 4;
const TOTAL_WIDTH = 340;
export default class MetricCard extends Component<Signature> {
  @use dataResource = staticDataResource(this, {
    serializedChart: () => this.countChartDefinition,
    reportState: () => this.args.reportState,
  });

  get countChartDefinition() {
    return {
      visualization_type: 'counter',
      view_by: null,
      chart_series: this.args.jobGroupObject.chartSeries,
    };
  }

  get totalTicks() {
    return Math.floor(TOTAL_WIDTH / TICK_WIDTH);
  }

  get percentageValue() {
    return this.dataResource.formatValue({
      value: this.dataResource.kpiData[0],
      metricId: this.args.jobGroupObject.chartSeries[0].metric_id,
    });
  }
  get positiveTicks() {
    let metricValue = this.dataResource.kpiData[0] as PercentageMetricValue;
    let value = Math.round(metricValue.value || 0);
    return Math.round((this.totalTicks * value) / 100);
  }

  get negativePercentageValue() {
    let value = this.dataResource.kpiData[0] as PercentageMetricValue;
    let mutatedValue = {
      ...value,
      value: ((value.denominatorValue - value.numeratorValue) / value.denominatorValue) * 100,
    };
    return this.dataResource.formatValue({
      value: mutatedValue,
      metricId: this.args.jobGroupObject.chartSeries[0].metric_id,
    });
  }

  get positiveNumeratorValue() {
    return (this.dataResource.kpiData[0] as PercentageMetricValue).numeratorValue;
  }

  get negativeNumeratorValue() {
    let value = this.dataResource.kpiData[0] as PercentageMetricValue;
    return value.denominatorValue - value.numeratorValue;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Automation::AiInsights::Optimize::MetricCard': typeof MetricCard;
    'reporting/automation/ai-insights/optimize/metric-card': typeof MetricCard;
  }
}
